import GodownItems from '../components/GodownItems';

const JWItems = () => {
  return <GodownItems type="JW" title="JW Items" />;
};

export default JWItems;
